import styled from 'styled-components';

/**
 * This form item currently only used for discount description in recalculation modal
 */
const FormItemWrapper = styled.div``;

export default FormItemWrapper;
